<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="user !== null">

    <div class="p-grid">
        <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
            <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
            <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'gender'" [control]="form.get('gender')" [type]="'select'" [options]="salutations" [label]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="t(user.getSalutation())"></app-form-control>
          <app-form-control [cid]="'firstname'" [control]="form.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')" [edit]="inEdit" [basevalue]="user.firstname"></app-form-control>
          <app-form-control [cid]="'lastname'" [control]="form.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')" [edit]="inEdit" [basevalue]="user.lastname"></app-form-control>
          <app-form-control [cid]="'company'" [control]="form.get('company')" [type]="'input'" [label]="t('common.labels.company')" [edit]="inEdit" [basevalue]="user.company"></app-form-control>
          <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(user.getLanguageName())" [options]="languages"></app-form-control>
        </div>
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="user.email"></app-form-control>
          <app-form-control [cid]="'phone'" [control]="form.get('phone')" [type]="'input'" [label]="t('common.labels.phone')" [edit]="inEdit" [basevalue]="user.phone"></app-form-control>
          <app-form-control [cid]="'mobile'" [control]="form.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')" [edit]="inEdit" [basevalue]="user.mobile"></app-form-control>
          <app-country-timezone [edit]="inEdit" [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="this.form.get('tz')"></app-country-timezone>
        </div>
    </div>

    <ng-container *ngIf="roleList !== null">
      <hr>
      <h2>{{ t('common.labels.roles') }}</h2>
      <p>{{ roleList }}</p>
    </ng-container>

    <ng-container *ngIf="inEdit === true">

      <hr>
      <h2>{{ t('my_profile.change_password') }}</h2>
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
              <app-form-control [cid]="'old'" [control]="form.get('passwords.old')" [type]="'password'" [label]="t('common.labels.old_password')"></app-form-control>
          </div>
          <div class="p-col-12 p-md-6">
              <app-form-control [cid]="'new'" [control]="form.get('passwords.new')" [type]="'password'" [label]="t('common.labels.new_password')"></app-form-control>
              <app-form-control [cid]="'confirm'" [control]="form.get('passwords.confirm')" [type]="'password'" [label]="t('common.labels.password_repetition')"></app-form-control>
              <app-form-error  *ngIf="form.get('passwords.confirm')?.value && form.get('passwords')?.errors?.passwordMatch" [control]="form.get('passwords')" [inline]="true">
                  {{ t('my_profile.passwords_do_not_match') }}
              </app-form-error>
          </div>
      </div>
    </ng-container>

  </form>
</ng-container>
